<template>
  <div class="add-interaction-form">
    <div class="row">
      <div class="form-group col-md-2">
        <label>Type</label>
        <select2 class="form-control tip" :options="available_options_types" v-model="selected_type" :disabled="is_fetching"></select2>
      </div>
      <div class="form-group tip col-md-2" v-if="selected_type == 'other'">
        <label>Autre type</label>
        <input type="text" class="tip form-control" v-model="other_type" :disabled="is_fetching"></input>
      </div>
      <div class="form-group tip col-md-2" v-if="selected_type == 'document_sending'">
        <label>Email</label>
        <input type="text" class="tip form-control" v-model="document_sending_email" :disabled="is_fetching"></input>
      </div>
      <div class="form-group form-group-default input-group marged-top col-md-2">
          <label>Date d'interaction</label>
          <input type="text" id="date-interact" class="form-control tip date-time-field" v-model="interaction_date" :disabled="is_fetching">
          <span class="input-group-addon">
                  <i class="fa fa-calendar"></i>
          </span>
      </div>
    </div>

    <div class="row" v-if="selected_type == 'document_sending'">
      <input type="hidden" v-model="medias">
      </input>
      <div class="col-md-2 form-group">
        <label>Agences</label>
        <select2 v-model="selected_agency" :options="agencies"></select2>
      </div>
      <div v-if="medias.length > 0 || selected_medias.length > 0" class="col-md-2 form-group">
        <label>Documents</label>
        <select2 v-model="selected_medias" :multiple="true" :options="medias"></select2>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label>Message</label>
        <textarea v-model="message" class="form-control tip"> :disabled="is_fetching"</textarea>
      </div>
    </div>
    <div class="pull-right">
      <button class="btn btn-success search_button" @click="try_post_interaction">Créer l'interaction</button>
      <button class="btn search_button" @click="$emit('cancel-interaction')">Annuler</button>
    </div>
    <!-- <slot @create="try_post_interaction"></slot> -->
  </div>
</template>
<script>
import {mapGetters,mapActions} from "vuex"
import Select2 from "components/Form/Select2"

export default {
  name:"CreationFormForInteraction",
  components:{
    Select2
  },
  data() {
    return {
      available_options_types:[
        {
          id:"phone_call",
          text:"Appel téléphonique"
        },
        {
          id:"email",
          text:"E-mail"
        },
        {
          id:"document_sending",
          text:"Envoi de documents"
        },
        {
          id:"other",
          text:"Autre"
        }
      ],
      selected_type:-1,
      other_type:"",
      interaction_date:"",
      document_sending_email:"",
      message:"",
      selected_agency:null,
      selected_medias:[],
    }
  },
  computed:{
    ...mapGetters("crm", ["is_fetching","current_lead","agencies", "medias","is_any_errors"]),
    body() {
      return {
          "interaction": {
            "type": this.selected_type,
            "other_type": this.other_type,
            "document_sending_email":this.document_sending_email,
            "message":this.message,
            "interaction_date": moment(this.interaction_date).format("YYYY-MM-DD HH:mm:ss"),
        }
      }
    }
  },
  methods:{
    ...mapActions("crm", ["create_interaction","set_fetching_state","fetch_interactions","reset_medias","fetch_medias","reset_errors"]),

    try_post_interaction()
    {
      this.set_fetching_state(true)
      this.reset_errors()
      this.create_interaction({lead_id:this.current_lead.id, body:this.body, medias:this.selected_medias})
          .then(() => {
              this.fetch_interactions(this.current_lead.id)
                  .then(() => this.set_fetching_state(false))
              if (!this.is_any_errors)
                this.$emit('cancel-interaction')
              })
    }
  },

  watch:{
    selected_agency : function () {
      // this.reset_medias()
      this.set_fetching_state(true)
      this.fetch_medias(this.selected_agency)
          .then(() => this.set_fetching_state(false))
    }
  },

  created() {
    this.$nextTick()
        .then(() => {
            $('#date-interact', this.$el).datepicker({
                format: "yyyy-mm-dd",
                language: "fr",
                autoclose: true,
                title: "Date d'interaction",
            }).on('changeDate', (e) => {
                this.interaction_date = e.target.value
            })
          })
  }
}
</script>
<style scoped>
.marged-top {
  margin-top:25px;
}
.add-interaction-form {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/Interactions/Form.vue